import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService } from '@app/services';

import { ReservationDetails, Review, ReviewKind } from '../../models';
import { ReviewService } from '../../services/review.service';
import { ErrorModalComponent } from '@oa/shared-core';
import { NewlineToBrPipe } from '../../shared-components/pipes/newline-to-br.pipe';
import { RatingDisplayComponent } from '../../shared-components/rating-display/rating-display.component';
import { FormsModule } from '@angular/forms';


@Component({
    selector: "review-editor",
    templateUrl: "./review-editor.component.html",
    styleUrls: ["./review-editor.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, RatingDisplayComponent, NewlineToBrPipe]
})
export class ReviewEditorComponent {
  private readonly _componentName = 'ReviewEditorComponent';
  private _review: Review = { text: '' } as Review;

  private ratings: number[] = [1, 2, 3, 4, 5];

  @Input() mode: 'create' | 'read' | 'update' = 'create';
  @Input() kind: ReviewKind.FromLandowner | ReviewKind.FromMember;

  public get review(): Review {
    return this._review;
  }

  @Input()
  public set review(v: Review) {
    this._review = v;
    this.waiting = false;
    this.changeDetector.detectChanges();
    console.log(`${this._componentName} review setter review=`, this.review);
  }

  @Output() save = new EventEmitter<Review>();
  @Input() reservation: ReservationDetails;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;

  public waiting: boolean;

  get readonly() {
    switch (this.mode) {
      case 'create':
      case 'update':
        return false;
      default:
        return true;
    }
  }

  constructor(readonly reviewService: ReviewService, private notify: NotificationService, private changeDetector: ChangeDetectorRef) {}

  onSubmit() {
    console.log(`${this._componentName}.onSubmit()`);

    this.waiting = true;

    try {
      switch (this.mode) {
        case 'create':
          this.createReview(this.createSubmitModel()).subscribe(
            r => {
              this.review = r;
              this.save.emit(this.review);
              this.waiting = false;
            },
            err => {
              console.error(err);
              this.notify.error('An error occured while saving review.', null);
            }
          );

          break;

        case 'update':
          this.save.emit(this.review);
          this.waiting = false;
          break;

        default:
          this.notify.notImplemented(`Submit ${this.mode}`);
          break;
      }
    } catch (e) {
      console.error(e.message || e);
      this.notify.error('An error occured while saving review.', null);
      this.waiting = false;
    }
  }

  createSubmitModel(): Review {
    return {
      ...this.review,
      kind: this.kind,
      reservationId: this.reservation.reservationId
    };
  }

  /**
   * areEqual
   */
  public areEqual(a: any, b: any) {
    console.log('areEqual', a, b);

    if (a == b) {
      console.log('areEqual return true');
      return true;
    }

    console.log('areEqual return false');
    return false;
  }

  createReview(create: Review) {
    console.log(`${this._componentName}.createReview()`);

    switch (this.kind) {
      case ReviewKind.FromMember:
        return this.reviewService.createReviewFromMember(create);
      case ReviewKind.FromLandowner:
        return this.reviewService.createReviewFromLandowner(create);
      default:
        throw Error('Unknown Review Kind');
    }
  }
}
